import MenuItem from '../../../../components/BrandMenuItem';

export default MenuItem;
